import {
  generateListingTitle,
  generateListingDescription,
  cleanupCanonicalUrl,
} from "@/libs/utils";
import { useRouter } from "next/router";
import { useMemo } from "react";
import Snippets from "./Snippets";
import Head from "next/head";
import { buildId, makeAbsoluteUrl, makeApiImage } from "@/libs/clientConfig";

type Props = {
  data: any;
};
const ListingMetaHeader = ({ data }: Props) => {
  const title = generateListingTitle(data);
  const description = generateListingDescription(data);
  const imageUrl = makeApiImage(data?.uploadImages[0]?.images);
  const currentUrl = makeAbsoluteUrl(`/listing/${data.slug}`);
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} key="description" />
      <meta key="twitter:url" name="twitter:url" content={currentUrl} />
      <meta key="og:url" name="og:url" content={currentUrl} />
      <meta key="og:title" property="og:title" content={title} />
      <meta key="twitter:title" property="twitter:title" content={title} />
      <meta key="twitter:image" property="twitter:image" content={imageUrl} />
      <meta key="og:image" property="og:image" content={imageUrl} />
      <meta
        key="og:description"
        property="og:description"
        content={description}
      />
      <meta
        key="twitter:description"
        property="twitter:description"
        content={description}
      />
      <meta
        key="twitter:image:alt"
        property="twitter:image:alt"
        content={description}
      />
      <meta
        key="twitter:creator"
        name="twitter:creator"
        content="_privateauto"
      />
      <meta key="twitter:site" name="twitter:site" content="_privateauto" />
      <meta key="og:type" name="og:type" content="website" />
      <meta key="og:site_name" name="og:site_name" content="PrivateAuto" />
      <link
        key="canonical"
        rel="canonical"
        href={cleanupCanonicalUrl(currentUrl)}
      />
      <meta
        key="buildmark"
        name="buildmark"
        content={JSON.stringify({ dt: new Date(), buildId })}
      ></meta>

      {data?.originalSourceInfo && (
        <meta name="robots" content="noindex"></meta>
      )}
    </Head>
  );
};

export default ListingMetaHeader;
